<template>
  <div id="app">
    <transition name="el-fade-in">
      <div class="loader-wrap" v-if="loader">
        <img class="logo" v-if="loading" src="@/assets/images/logo_loader.png" alt="">
        <div class="loadingbar" v-if="loading">
          <div class="processbar" id="processbar"></div>
        </div>
        <div class="num" id="loadingratio" v-if="loading">0%</div>
      </div>
    </transition>
    <HeaderM v-show="HeaderMShow" :class="{show:HeaderMShow}" />
    <div id="page" :class="{menushow:HeaderMShow}">
      <Header @menushow="menushow" />
      <div id="scroller-wrapper" data-scrollbar>
        <router-view @pagetransition="pagetransition"/>
        <Footer />
      </div>
    </div>
    <div class="transition" v-if="transition">
      <div class="inner"></div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import HeaderM from '@/components/Header-m.vue';
import Footer from '@/components/Footer.vue';
import Scrollbar from 'smooth-scrollbar';
import {WOW} from 'wowjs'
import { setTimeout } from 'timers';
export default {
  components: {
    Header,
    HeaderM,
    Footer
  },
  data(){
    return{
      transition:false,
      loader:true,
      loading:false,
      HeaderMShow: false
    }
  },
  mounted(){
    Scrollbar.initAll();
    this.$router.beforeEach((to, from, next) => {
      if(document.body.clientWidth>768){
        this.pagetransition()
        setTimeout(()=>{
          Scrollbar.destroyAll()
          next()
        },2000)
      }else{
        Scrollbar.destroyAll()
        next()
      }
    })
    this.$nextTick(() => {
      setTimeout(()=>{
        this.loading=true
        this.loadingAddNum(0, 10);
      },1000)
    });
  },
  watch: {
    $route: 'updateScrollbar'
  },
  methods: {
    updateScrollbar(){
      this.HeaderMShow=false
      this.$nextTick(()=>{
        Scrollbar.initAll();
        this.wowinit()
      })
    },
    wowinit(){
      this.$nextTick(()=>{
        let wow=new WOW({offset:200})
        wow.init()
        window.pageYOffset=0
        let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
        scrollbar.addListener((status) => {
          window.pageYOffset=status.offset.y
          wow.scrollHandler()
        });
      })
    },
    pagetransition(){
      this.HeaderMShow=false
      if(document.body.clientWidth>768){
        this.transition=true
        setTimeout(()=>{
          this.transition=false
        },2000)
      }
      
    },
    loadingAddNum(num, step) {
      setTimeout(() => {
        const processbar = document.getElementById('processbar');
        const loadingratio = document.getElementById('loadingratio');
        processbar.style.width = num + '%';
        loadingratio.innerText = num + '%';

        if (num < 99) {
          let startNum = Math.ceil(num + step);
          if (startNum > 100) {
            startNum = 100;
          }
          this.loadingAddNum(startNum, step);
        } else {
          setTimeout(()=>{
            this.loader=false
            this.wowinit()
          },1000)
          
        }
      }, 200);
    },
    menushow(HeaderMShow){
      this.HeaderMShow=HeaderMShow
    }
  }
}
</script>


<style>
*{box-sizing: border-box;margin: 0;padding: 0;}
body{
  margin:0;
  padding:0;
  font-family: Arial, "Microsoft YaHei", sans-serif;
  color: #000;
}
img{
  vertical-align: middle;
  max-width: 100%;
}
p{margin: 0;}
a{
  text-decoration: none;
  color: inherit;
}
ul,li{
  list-style: none;
}
.clearfix::before,.clearfix::after{
  content: "";
  display: table;
  
}
.clearfix::after{
  clear: both;
}
.flex{
  display:flex;
}
.flex-space-between{
  justify-content: space-between;
}
.flex-content-center{
  justify-content: center;
}
.flex-space-around{
  justify-content: space-around;
}
.flex-align-center{
  align-items: center;
}
.flex-wrap{
  flex-wrap: wrap;
}
.flex-column{
  flex-direction: column;
}
#app{
  overflow: hidden;
}
#page{
  transition: .4s;
  position: relative;
  z-index: 102;
}
#page.menushow{
  transform: translate(80%,0);
}
.w1320{
  width: 1320px;
  max-width: 100%;
  margin: 0 auto;
}
#scroller-wrapper{
  position: relative;
  height: 100vh;
  z-index: 101;
}
#scroller-wrapper .scrollbar-thumb{
  background-color: #63818f;
}
</style>

<style scoped>
.loader-wrap{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 88px solid #5e7987;
  background-color: #fff;
  z-index: 111;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.loader-wrap::before{
  content: '';
  position: absolute;
  left: 0;
  width: 100%;
  height: 50%;
  background-color: #5e7987;
	animation-name: zoom;
	animation-duration: 4s;
  animation-fill-mode:forwards;
}
.loader-wrap::after{
  content: '';
  position: absolute;
  left: 0;
  width: 100%;
  height: 50%;
  background-color: #5e7987;
	animation-name: zoom2;
	animation-duration: 4s;
  animation-fill-mode:forwards;
}
@keyframes zoom {
  0% {
    height: 50%;
    top: 0;
  }
  25% {
    height: 0;
    top: 0;
  }
  75% {
    height: 0;
    bottom: 50%;
  }
  100% {
    height: 50%;
    top: auto;
    bottom: 50%;
  }
}
@keyframes zoom2 {
  0% {
    height: 50%;
    bottom: 0;
  }
  25% {
    height: 0;
    bottom: 0;
  }
  75% {
    height: 0;
  }
  100% {
    height: 50%;
    bottom: auto;
    top: 50%;
  }
}
.loader-wrap .logo{
  position: absolute;
  bottom: 50%;
  margin-bottom: 32px;
}
.loader-wrap .num{
  position: absolute;
  top: 50%;
  margin-top: 20px;
  font-size: 19px;
  color: #5e7987;
  font-family: 'Embassy BT';
}
.loader-wrap .loadingbar{
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #ececec;
}
.loader-wrap .loadingbar .processbar{
  width: 0;
  height: 1px;
  background-color: #5e7987;
}
.transition{
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
	animation-name: transition;
	animation-duration: 1s;
  animation-fill-mode:forwards;
  z-index: 110;
}
.transition .inner{
  background-color: #5e7987;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0;
	animation-name: transition;
	animation-duration: 1s;
  animation-delay: 1s;
  animation-fill-mode:forwards;
}
@keyframes transition {
  0% {
    height: 0;
  }
  100% {
    height: 100%;
  }
}
@media(max-width: 768px){
  .loader-wrap{
    border-width: 20px;
  }
}
</style>

